import { render, staticRenderFns } from "./CreatePostVideo.vue?vue&type=template&id=2696f18a&"
import script from "./CreatePostVideo.vue?vue&type=script&lang=js&"
export * from "./CreatePostVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports